export default import.meta.ROLLUP_FILE_URL_cLLFq7OX38PQjR0WE41fig;